<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="footer">
      <div class="footer-upper">
        <div class="auto-container">
          <div class="w-full flex flex-wrap">
            <div class="w-full md:w-4">
              <div class="logo" style="display: flex;align-items: center; padding:0px 10px;">
                <a href="/"><img :src="require('@/assets/logo.png')" alt="" style="height:60px;" /></a>
              </div>
            </div>
            <div class="w-full md:w-8 block">
              <div class="block-container">
                <div class="w-full mb-3 sm:mb-0 sm:w-4" style="text-align:left;">
                  <div @click="fc_goRoute('termosCondicoes')" class="w-full footer-link" v-html="fc_getText(null, 'termosCondicoes')"></div>
                  <div @click="fc_goRoute('politicaDePrivacidade')" class="w-full footer-link" v-html="fc_getText(null, 'politicaDePrivacidade')"></div>
                  <div @click="fc_goRoute('politicaDeCookies')" class="w-full footer-link" v-html="fc_getText(null, 'politicaDeCookies')"></div>
                  <div @click="fc_goRoute('contactos')" class="w-full footer-link" v-html="fc_getText(null, 'contactos')"></div>
                </div>
                <div class="w-full mb-3 sm:mb-0 sm:w-4" style="text-align:left;">
                  <div class="w-full footer-contact" v-if="(item.email != '' && item.email != null)">
                    <i class="icon pi pi-fw pi-envelope"></i>
                    <a :href="'mailto:'+item.email"><span v-html="item.email" class="ml-1"></span></a>
                  </div>
                  <div class="w-full footer-contact" v-if="(item.emailAlternativo != '' && item.emailAlternativo != null)">
                    <i class="icon pi pi-fw pi-envelope"></i>
                    <a :href="'mailto:'+item.emailAlternativo"><span v-html="item.emailAlternativo" class="ml-1"></span></a>
                  </div>
                  <div class="w-full footer-contact" v-if="(item.telefone != '' && item.telefone != null)">
                    <i class="icon pi pi-fw pi-phone"></i>
                    <span v-html="item.telefone" class="ml-1"></span>
                    <span v-if="(item.chamadaRedeFixa)" style="display:block;" v-html="fc_getText(null, 'chamadaRedeFixa')"></span>
                  </div>
                </div>
                <div class="footer-redesSociais w-full sm:w-2 flex flex-row sm:flex-column mt-4 sm:mt-0 text-center">
                  <a v-if="(item.linkLinkedin != '')" :href="item.linkLinkedin" target="_blank">
                    <span class="icon pi pi-fw pi-linkedin text-xl"></span>
                  </a>
                  <a v-if="(item.linkFacebook != '')" :href="item.linkFacebook" target="_blank">
                    <span class="icon pi pi-fw pi-facebook text-xl"></span>
                  </a>
                  <a v-if="(item.linkInstagram != '')" :href="item.linkInstagram" target="_blank">
                    <span class="icon pi pi-fw pi-instagram text-xl"></span>
                  </a>
                  <a v-if="(item.linkYoutube != '')" :href="item.linkYoutube" target="_blank">
                    <span class="icon pi pi-fw pi-youtube text-xl"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Bottom-->
      <div class="footer-bottom w-full">
        <div class="auto-container flex flex-wrap" style="border-top:1px solid #ccc; padding: 15px 15px 20px 15px">
          <div class="w-full sm:w-6">
            <p style="color:white;" v-html="mt_copyright()"></p>
          </div>
          <div class="w-full sm:w-6 hidden sm:block text-right">
            <p style="color:white;" v-html="fc_getText(null, 'designedBy')"></p>
          </div>
          <div class="block sm:hidden w-full text-left">
            <p style="color:white;" v-html="fc_getText(null, 'designedBy')"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      loaded: false,
      item: {}
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.loaded = true;
    },
    mt_copyright() {
      let string = this.fc_getText(null, 'copyright');
      const anoAtual = new Date().getFullYear();
      return string.replace("YEAR", anoAtual);
    },
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ContactosPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.footer {
  background-color: #222;
}
.footer .footer-bottom {
  position: relative;
}
.footer .footer-upper {
  position: relative;
  padding: 40px 0 20px;
}
.footer .logo {
  cursor: pointer;
  transition: all 0.3s ease 0s;
}
.footer .logo:hover {
  transform: translateX(6%);
  transition: all 0.3s ease 0s;
}
.footer .block {
  text-align: right;
  padding:20px 15px 20px 0px;
}
.footer .block-container {
  display:flex;
  justify-content: space-between;
  color:white;
  align-items: center;
  padding: 0px 10px 0px 10px;
  flex-flow: wrap;
}
.footer-redesSociais .icon {
  color: var(--ibase-color);
  font-size:20px;
}
.footer-redesSociais .icon:hover {
  color: #23527c;
  font-size:20px;
}
.footer-link {
  cursor: pointer;
}
.footer-link,
.footer-contact i,
.footer-contact span {
  font-size:16px;
  vertical-align: middle;
}
.footer-link:hover,
.footer-contact a:hover {
  color: var(--ibase-color);
}
</style>
